"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_input_mask_1 = __importDefault(require("react-input-mask"));
const JkcMask = (props) => {
    const { name, settings, onBlurEvent, onChangeEvent } = props;
    const onfocus = (event) => {
        event.target.setSelectionRange(14, 15);
        setCursorPosition(event);
    };
    const onKeyDown = (event) => {
        if (event.keyCode === 8) {
        }
        else {
            setCursorPosition(event);
        }
    };
    const setCursorPosition = (event) => {
        setTimeout(() => {
            let length = event.target.value.replaceAll(' ', '').replaceAll('-', '').replaceAll('(', '').replaceAll(')', '').replaceAll('#', '').length;
            if (length === 0) {
                event.target.setSelectionRange(1, 2);
            }
            else if (length > 0 && length < 3) {
                event.target.setSelectionRange(length + 1, length + 2);
            }
            else if (length === 3) {
                event.target.setSelectionRange(6, 7);
            }
            else if (length > 3 && length < 6) {
                event.target.setSelectionRange(length + 3, length + 4);
            }
            else if (length === 6) {
                event.target.setSelectionRange(10, 11);
            }
            else if (length > 6 && length < 10) {
                event.target.setSelectionRange(length + 4, length + 5);
            }
            else if (length === 10) {
                event.target.setSelectionRange(14, 15);
            }
        }, 200);
    };
    let labelStyle = {
        marginBottom: "0px",
        position: settings.isNormalLabel ? "relative" : "absolute",
    };
    let inputStyle = {
        width: "100%",
        padding: settings.isNormalLabel ? "0px 7px 0px 7px" : "10px 7px 0px 7px",
        fontSize: "15px",
        border: "1px solid #D3D3D3",
        outline: "none",
        textAlign: "left",
    };
    let fieldStyle = {
        position: "relative",
        width: '100%',
        display: (settings.fieldTypes == 'Grid') ? 'flex' : 'block',
        borderTop: (settings.fieldTypes == 'Grid') ? '1px solid #dddddd' : 'none',
        borderBottom: (settings.fieldTypes == 'Grid') ? '1px solid #dddddd' : 'none',
        marginTop: "-1px"
    };
    if (settings.fieldTypes == 'Grid') {
        fieldStyle.alignItems = 'center';
    }
    let fieldLablStyle = {
        width: (settings.fieldTypes == 'Grid') ? '30%' : '100%',
        padding: (settings.fieldTypes == 'Grid') ? '10px 10px' : '0px'
    };
    let fieldInputStyle = {
        width: (settings.fieldTypes == 'Grid') ? '70%' : '100%',
        padding: (settings.fieldTypes == 'Grid') ? '10px 10px' : '0px',
        borderLeft: (settings.fieldTypes == 'Grid') ? '1px solid #dddddd' : 'none',
        position: 'relative'
    };
    if (settings.fieldTypes == 'Grid') {
        fieldLablStyle.textAlign = 'right';
    }
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ style: fieldStyle, className: "component-area-cn" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ style: fieldLablStyle }, { children: !settings.hideLabel ? ((0, jsx_runtime_1.jsx)("label", Object.assign({ style: Object.assign(Object.assign({}, labelStyle), settings.labelStyle), htmlFor: name }, { children: settings.label ? settings.label : "Label" }))) : null })), (0, jsx_runtime_1.jsx)("div", Object.assign({ style: fieldInputStyle }, { children: (0, jsx_runtime_1.jsx)(react_input_mask_1.default, { className: "jkc-input-mask", name: name, value: settings.value, style: Object.assign(Object.assign({}, inputStyle), settings.inputStyle), mask: settings.mask, maskChar: settings.maskChar, alwaysShowMask: settings.alwaysShowMask, onChange: onChangeEvent, onBlur: onBlurEvent, onFocus: onfocus, onKeyDown: onKeyDown }) }))] })));
};
exports.default = JkcMask;
